var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.39b22b3e85ed8baaff5da19009548bb0.svg#m';
                    var viewUrl = 'sprites.39b22b3e85ed8baaff5da19009548bb0.svg#view-m';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };